import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@services/route.service';
import { User } from '@services/user.service';

@Component({
  selector: 'lgb-avatar',
  standalone: false,
  templateUrl: './avatar.html',
  styleUrl: './avatar.css',
})
export class Avatar {
  readonly clickable=input(true);
  readonly user=inject(User);
  readonly inital=computed(() => `${this.user.user().name.substring(0,1)}${this.user.user().lastname.substring(0,1)}`);
  readonly router=inject(Router);
  readonly img=computed(() => this.user.getImg()+'?v='+Date.now());
}
